// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".width-order-overview[data-v-0d5bcaa9]{max-width:500px;margin-left:auto;margin-right:auto}.warning[data-v-0d5bcaa9]{color:#ff7272}.loading-section[data-v-0d5bcaa9]{display:flex;align-items:center;justify-content:center;padding:20px;color:#666}.loading-text[data-v-0d5bcaa9]{margin-left:8px}", ""]);
// Exports
module.exports = exports;
